import React from "react";
import { useDispatch } from "react-redux";
import { SW_LOGO_ICON } from "../../../../../actions/api";
import { togglePlanSection_D } from "../../../../../actions/showDisplayModalAction";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";
import { Button, Image } from "react-bootstrap";


export default function PricingHeader(props) {
    const dispatch = useDispatch();

    const handleBackButton = () => {
        if (props.checkout === null && !props.showOneDayPlan) {
            dispatch(togglePlanSection_D(false));

        } else {
            if (props.showOneDayPlan) {
                props.setOneDayPlan(false)
            }
            props.setCheckout(null);
        }
    }
    return <>
        <div className="d-flex align-items-center justify-content-between border-bottom page_custom_header">
            <div className="d-flex align-items-center flex-nowrap">
                <Button variant="link" className="p-3 border-0 border-end rounded-0 change-plan" onClick={() => handleBackButton()}>
                    <FontAwesomeIcon type={'regular'} icon={'angle-left'} iconClass={''} />
                </Button>
                <h5 className="m-0 text-nowrap overflow-hidden ms-4 d-none" id="exampleModalLongTitle">
                    Plans &amp; Pricing
                </h5>
                <div className="main_title">
                    <h3>
                        <Image className="img-fluid productIcon" src={SW_LOGO_ICON} width={52} height={52} alt="" />
                        {props.route === 'socialwalls' ? 'Social Walls' : 'Widget'} <span>- Plans &amp; Pricing </span>
                    </h3>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-end close_btn">
                <Button variant="link" className="rounded-0 p-3" onClick={() => { handleBackButton() }}>
                    <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={''} />
                </Button>
            </div>
        </div>

    </>

}